/* eslint-disable no-console */
import { drupalComponent } from '@nech/src/helpers/drupal-component';

(function (Drupal, once, $) {
  drupalComponent('video', {
    shared: undefined,
    selector: '.video-container',
    instance($el) {
      const $iframe = $el.find('iframe');
      const $playButton = $el.find('[aria-label="Play video"]');
      const videoSrc = $iframe.attr('src') || '';

      const playVideo = () => {
        if ($iframe.length && videoSrc) {
          $iframe.attr('src', `${videoSrc}&autoplay=1`);
          $playButton.hide();
          $iframe.attr('tabindex', '0').trigger('focus');
        }
      };

      $playButton.on('click', playVideo);

      $playButton.on('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          playVideo();
        }
      });
    },
  });
})(Drupal, once, jQuery);
